import { render, staticRenderFns } from "./pagination.html?vue&type=template&id=190a7ea2&scoped=true&external"
import script from "./pagination.js?vue&type=script&lang=js&external"
export * from "./pagination.js?vue&type=script&lang=js&external"
import style0 from "./pagination.scss?vue&type=style&index=0&id=190a7ea2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190a7ea2",
  null
  
)

export default component.exports